import { ViewAllProps } from '../../types';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { getSeoUrl } from 'utils/links';
import { HEADLESS_MY_EQUIPMENT_LINK } from 'constants/links';
import { CatButton } from 'components/blocks-components';

export const ViewAll = ({ children }: Readonly<ViewAllProps>) => {
  // TODO - Input Validation - Ensure that all values used from params are allowed values:
  // lang should always be a two-digit string without numbers or special characters (like 'es');
  // esite should always be a string without numbers or special characters, except for the dash (like demo-dealer).
  const params: esiteParams = useParams();
  const myEquipmentLink = getSeoUrl(params, HEADLESS_MY_EQUIPMENT_LINK);

  return (
    <Link href={{ pathname: myEquipmentLink }}>
      <CatButton variant="inline">{children}</CatButton>
    </Link>
  );
};
